import { getApiClient } from "./apiClient";

export interface CreditSummary {
  total_available: string;
  total_granted: string;
  total_consumed: string;
  active_balance_count: number;
}

export interface CreditBalance {
  id: string;
  original_volume: string;
  remaining: string;
  source: string;
  valid_from: string;
  valid_until: string;
  is_active: boolean;
  notes: string;
  utilization_percentage: number;
  is_expired: boolean;
  created_at: string;
}

export interface UsageHistoryEntry {
  date: string;
  credits: number;
}

class BillingApi {
  async getSummary(): Promise<CreditSummary> {
    const client = await getApiClient();
    const response = await client.get("/billing/summary/");
    return response.data;
  }

  async getBalances(): Promise<CreditBalance[]> {
    const client = await getApiClient();
    const response = await client.get("/billing/balances/");
    return response.data.results ?? response.data;
  }

  async getUsageHistory(days: number = 30): Promise<UsageHistoryEntry[]> {
    const client = await getApiClient();
    const response = await client.get("/billing/usage-history/", {
      params: { days },
    });
    return response.data;
  }
}

export const billingApi = new BillingApi();
